import { HttpClient } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { Observable, Subject, finalize, map } from 'rxjs';
import { DialogService } from 'src/app/services/dialog.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { OperatoriProiecteService } from './operatori-proiecte.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import Swal from 'sweetalert2';
import { IOperator } from './operatori-proiecte.interface';
import { EditOperatoriProiecteComponent } from './edit-operatori-proiecte/edit-operatori-proiecte.component';
import { UpdateFunctieOperatoriProiecteComponent } from './update-functie-operatori-proiecte/update-functie-operatori-proiecte.component';
import { FormControl, FormGroup } from '@angular/forms';
import { Generic, GenericUser } from 'src/app/interfaces/generic.interface';
import { CommonService } from 'src/app/services/common.service';


@Component({
    selector: 'app-operatori-proiecte',
    templateUrl: './operatori-proiecte.component.html',
    styleUrls: ['./operatori-proiecte.component.scss']
})
export class OperatoriProiecteComponent {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;

    helper = helper;
    isLoading = false;
    isFilterLoading = false;
    showCard = false;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    functiiMap: { [key: number]: string } = {};
    functiiActive!: Generic[];
    directiiActive!: Generic[];
    compartimenteActive$!: Observable<Generic[]>;

    dtLink =
        environment.interop.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteOperatori.listDT;

    defaultParameter: { name: string; id: string } = {
        name: 'Toate',
        id: '-1',
    };

    searchParamsForm!: FormGroup;

    initialFormValues = {
        name: '',
        functie: '-1',
        directie: '-1',
        compartiment: '-1',
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            name: new FormControl(''),
            functie: new FormControl('-1'),
            directie: new FormControl('-1'),
            compartiment: new FormControl('-1'),
        });
    }

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }

    constructor(
        private dialogService: DialogService,
        private http: HttpClient,
        private dialog: MatDialog,
        private operatoriProiecteService: OperatoriProiecteService,
        public permissionsService: PermissionsService,
        public commonService: CommonService,
    ) { }

    ngOnInit(): void {
        this.renderDT();
        this.loadFunctiiActive();
        this.loadDirectiiActive();
        this.buildSearchParamsForm();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            searching: false,
            responsive: true,
            pageLength: 25,

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.filters = this.searchParamsForm.value;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsTotal,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id_user',
                },
                {
                    title: 'Nume',
                    data: 'name',
                },
                {
                    title: 'Funcție',
                    data: 'functie_id',
                    render: (data: any) => this.functiiMap[data] || 'N/A',
                },
                {
                    title: 'Instituție',
                    data: 'denumire_sesizare_departament',
                    render: function (data: any) {
                        return data === null || data === undefined ? 'N/A' : data;
                    },
                },
                {
                    title: 'Compartiment',
                    data: 'denumire_sesizare_compartiment',
                    render: function (data: any) {
                        return data === null || data === undefined ? 'N/A' : data;
                    },
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    className: 'all',
                    orderable: false,
                    render: (data: any, type: any, row: any, met: any) => {
                        return (
                            `
                            <div class="d-flex align-center">
                                <button class="action-btn edit" title="Actualizare drepturi">
                                    <img class="btn-img" src="/assets/icons/edit.svg" alt="edit"/>
                                </button>
                                <button type="button" class="action-btn signatures ms-1" title="Actualizare funcție">
                                    <img class="btn-img" src="/assets/icons/simple-signature-contract.svg" alt="signatures"/>
                                </button>

                                <button type="button" class="action-btn update_status_responsible ms-1 ` +
                            (row.responsabil_proiect == true ? 'action-success' : 'action-danger') +
                            `" title="Schimbare status responsabil">
                                    <img class="btn-img" src="` +
                            (row.responsabil_proiect == true ? '/assets/icons/responsible-white-check.svg' : '/assets/icons/responsible-white-close.svg') +
                            `" alt="update_status_responsible"/>
                                </button>

                                <button type="button" class="action-btn update_status_agent ms-1 ` +
                            (row.agent_teren == true ? 'action-success' : 'action-danger') +
                            `" title="Schimbare status agent teren">
                                    <img class="btn-img" src="` +
                            (row.agent_teren == true ? '/assets/icons/agent-white.svg' : '/assets/icons/agent-white.svg') +
                            `" alt="update_status_agent"/>
                                </button>
                            </div>
                            `
                        );
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;
                const signaturesIcon = lastTd?.querySelector('.signatures') as HTMLElement;
                const responsibleIcon = lastTd?.querySelector('.update_status_responsible') as HTMLElement;
                const agentIcon = lastTd?.querySelector('.update_status_agent') as HTMLElement;

                if (editIcon) {
                    // if (!this.permissionsService.hasPermission('monitoring-module.proiecte.categorii.update')) {
                    //     editIcon.style.display = 'none';
                    // }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (signaturesIcon) {
                    // if (!this.permissionsService.hasPermission('monitoring-module.proiecte.categorii.update')) {
                    //     signaturesIcon.style.display = 'none';
                    // }
                    signaturesIcon.addEventListener('click', () => {
                        this.openUpdateFunctieOperator(data);
                    });
                }

                if (responsibleIcon) {
                    // if (!this.permissionsService.hasPermission('monitoring-module.proiecte.categorii.update')) {
                    //     responsibleIcon.style.display = 'none';
                    // }
                    responsibleIcon.addEventListener('click', () => {
                        const { id_user } = data;
                        this.changeStatusResponsabil(id_user);
                    });
                }

                if (agentIcon) {
                    // if (!this.permissionsService.hasPermission('monitoring-module.proiecte.categorii.update')) {
                    //     agentIcon.style.display = 'none';
                    // }
                    agentIcon.addEventListener('click', () => {
                        const { id_user } = data;
                        this.changeStatusAgent(id_user);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(resetPaging = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(resetPaging);
        });
        this.showCard = false;
    }

    openEditDialog(data: IOperator) {
        const dialogRef = this.dialog.open(EditOperatoriProiecteComponent, {
            maxHeight: '80vh',
            minWidth: '50vw',
            maxWidth: '80vw',
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Operator actualizat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openUpdateFunctieOperator(data: IOperator) {
        const dialogRef = this.dialog.open(UpdateFunctieOperatoriProiecteComponent, {
            maxHeight: '40vh',
            minWidth: '50vw',
            maxWidth: '90vw',
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Operator actualizat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    loadDirectiiActive() {
        this.isFilterLoading = true;

        this.commonService.getDirectiiActive().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isFilterLoading = false))
        ).subscribe({
            next: (results) => {
                this.directiiActive = results;
            },
            error: (error) => {
                console.error('Error loading directii', error);
            },
        });;
    }

    onDirectieChange(directieId: number): void {
        if (directieId > 0) {
            this.loadCompartimenteActive(directieId);
        } else {
            this.compartimenteActive$ = new Observable<Generic[]>((observer) => {
                observer.next([{ name: 'Toate', id: -1 }]);
                observer.complete();
            });
        }
    }

    loadCompartimenteActive(directieId?: number) {
        this.isFilterLoading = true;
        let compartimenteObservable$ = directieId
            ? this.commonService.getCompartimenteByDirectie(directieId)
            : this.commonService.getCompartimenteActive();

        this.compartimenteActive$ = compartimenteObservable$.pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => {
                this.isFilterLoading = false;
            })
        );
    }

    loadFunctiiActive() {
        this.isFilterLoading = true;

        this.commonService.getFunctiiActive().pipe(
            finalize(() => (this.isFilterLoading = false))
        ).subscribe({
            next: (results) => {
                this.functiiActive = [this.defaultParameter, ...results];

                // functiiMap, needed for listDT
                results.forEach((item) => {
                    this.functiiMap[item.id] = item.name;
                });
            },
            error: (error) => {
                console.error('Error loading functii', error);
            },
        });;
    }

    changeStatusResponsabil(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să actualizați statusul de responsabil al operatorului selectat!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusResponsabilAction(id);
            }
        });
    }

    changeStatusResponsabilAction(id: number) {
        this.isLoading = true;
        this.operatoriProiecteService.changeStatusResponsabil(id).subscribe({
            next: () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Operator actualizat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            error: (err) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'error',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        // we do this because we need to have some control on activity
                        this.changeStatusResponsabilAction(id);
                    }
                });
            }
        });
    }

    changeStatusAgent(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să actualizați statusul de agent teren al operatorului selectat!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusAgentAction(id);
            }
        });
    }

    changeStatusAgentAction(id: number) {
        this.isLoading = true;
        this.operatoriProiecteService.changeStatusAgent(id).subscribe({
            next: () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Operator actualizat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            error: (err) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'error',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        // we do this because we need to have some control on activity
                        this.changeStatusAgentAction(id);
                    }
                });
            }
        });
    }
}
